import React from 'react';
import './column.scss';

const Column = ({size, children}) => (
  <div className={`col col--${size}`}>
    {children}
  </div>
)

export default Column



// WEBPACK FOOTER //
// ./src/components/column/index.js